/** [P7B §4f] How many publish previews the bulk-publish page asks for at once. */
export const PREVIEW_CONCURRENCY = 4;

/**
 * ⚠️ [P7B §4f] A BOUNDED POOL — at most `limit` requests in flight, results in INPUT order.
 *
 * One publish-preview per draft for a whole festival set is ~180 requests; firing them at once would
 * queue behind each other on the API's connection pool and starve every other screen the operator has
 * open. Four at a time keeps the page moving and the server breathing. `onSettled` reports progress.
 */
export const mapWithConcurrency = async <T, R>(
  items: readonly T[],
  limit: number,
  run: (item: T) => Promise<R>,
  onSettled?: (done: number) => void,
): Promise<R[]> => {
  const results = new Array<R>(items.length);
  let next = 0;
  let done = 0;
  const worker = async (): Promise<void> => {
    while (next < items.length) {
      const at = next;
      next += 1;
      results[at] = await run(items[at] as T);
      done += 1;
      onSettled?.(done);
    }
  };
  await Promise.all(Array.from({ length: Math.min(Math.max(limit, 1), items.length) }, () => worker()));
  return results;
};
